// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_FAB_FAMILY_COLLECTION: 'family_collection_badge',
    HA_FAB_FILTERS_2LESSGREYOUT: 'ha_fab_filters_2lessGreyout',
    HA_FAMILY_COLLECTION_BADGE_SERP_AD: 'ha_family_collection_badge_SERPad',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_IDA_SERP_HEADER_LOGIN_TEST: 'HA_IDA_SERP_HEADER_LOGIN_TEST',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_MULTIUNIT_DECORATOR_TEST: 'ha_multiunit_decorator_test',
    HA_MULTIUNIT_PHOTO_CAROUSEL_TEST: 'HA_MULTIUNIT_PHOTO_CAROUSEL_TEST',
    HA_PTA_AFFILIATE_CO_BRAND: 'HA_PTA_AFFILIATE_CO_BRAND',
    HA_PTA_AFFILIATE_CO_BRAND_SHOW_LOGO: 'HA_PTA_AFFILIATE_CO_BRAND_SHOW_LOGO',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PTA_LANDING_R1ADSONSERP: 'HA_PTA_LANDING_R1AdsOnSERP',
    HA_PULSE_COACHMARK_VIEW_BOARD: 'ha_pulse_coachmark_view_board',
    HA_PULSE_MWEB_MODAL_LIST_VIEW: 'ha_pulse_mweb_modal_list_view',
    HA_PULSE_SAVE_CONFIRMATION_SERP_HIT: 'ha_pulse_save_confirmation_serp_hit',
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS',
    HA_SERP_GTS_THROTTLE: 'HA_SERP_GTS_THROTTLE',
    HA_SERP_MIN_MAX_PRICE_FIELDS: 'HA_SERP_MIN_MAX_PRICE_FIELDS',
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS',
    HA_SERP_SEARCH_TERM_CAROUSEL2: 'HA_SERP_SEARCH_TERM_CAROUSEL2',
    HA_SRS_SERIAL_PERCENT_BOOKED: 'HA_SRS_SERIAL_PERCENT_BOOKED',
    HA_TYPEAHEAD_HIGHLIGHTS: 'ha_typeahead_highlights',
    HA_TYPEAHEAD_SCROLL_TO_TOP: 'HA_TYPEAHEAD_SCROLL_TO_TOP',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display',
    VRBO_OPAS_SECONDARY_PRICE: 'vrbo_opas_secondary_price'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
